module.exports = __webpack_public_path__ + "img/CV.1659906a.png";